// extracted by mini-css-extract-plugin
module.exports = {"bsHeader":"bsHeader_1pFWl","divider":"divider_KtIRi"};